import { Type } from '@sinclair/typebox';
import { LiftPlanUESchema } from '../../domain/lift-plan-ue/lift-plan-ue-schema.js';
import { NullishType } from '../../standard-schema.js';
export { LiftPlanUEAtaSchema, LiftPlanUEEntrySchema, LiftPlanUESchema, LiftPlanUESubtotalSchema, } from '../../domain/lift-plan-ue/lift-plan-ue-schema.js';
export const GetLiftPlanUEResponseSchema = Type.Array(LiftPlanUESchema);
export const LiftPlanUEProjectParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const LiftPlanUEParamsSchema = Type.Object({
    projectId: Type.String(),
    liftPlanId: Type.String(),
});
export const PutLiftPlanUEBodyEntrySchema = Type.Object({
    number: Type.Number(),
    description: NullishType(Type.String()),
    dueDate: NullishType(Type.String()),
    amount: Type.Number(),
    retention: Type.Number(),
    amountDue: Type.Number(),
    invoicedDate: NullishType(Type.String()),
    paymentDate: NullishType(Type.String()),
    comment: NullishType(Type.String()),
});
export const PutLiftPlanUEBodySubtotalSchema = Type.Object({
    description: Type.String(),
    amount: Type.Number(),
    invoicedDate: NullishType(Type.String()),
    paymentDate: NullishType(Type.String()),
    comment: NullishType(Type.String()),
});
export const PutLiftPlanUEBodyAtaSchema = Type.Object({
    description: Type.String(),
    amount: Type.Number(),
    invoicedDate: NullishType(Type.String()),
    paymentDate: NullishType(Type.String()),
    comment: NullishType(Type.String()),
});
export const PutLiftPlanUEBodySchema = Type.Object({
    name: Type.String(),
    contractSum: Type.Number(),
    retentionPercentage: Type.Number(),
    entries: Type.Array(PutLiftPlanUEBodyEntrySchema),
    subtotals: Type.Array(PutLiftPlanUEBodySubtotalSchema),
    atas: Type.Array(PutLiftPlanUEBodyAtaSchema),
});
